import OverflowTooltip from '../OverflowTooltip';
import { TypeChip, TypeChipLabel } from './typeChip';

const isCloudSourceType = (value: string) =>
  value === 'cloud' || value === 'elementary_cloud';

const testSourceTypeRenderer = (value: string) =>
  isCloudSourceType(value) ? (
    <TypeChip>
      <TypeChipLabel>CLOUD</TypeChipLabel>
    </TypeChip>
  ) : (
    <OverflowTooltip>{value}</OverflowTooltip>
  );

export default testSourceTypeRenderer;
